import { render } from "./TableDesktop.vue?vue&type=template&id=2a2b70e8"
import script from "./TableDesktop.vue?vue&type=script&lang=js"
export * from "./TableDesktop.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__